// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b27ac3d0","667":"e14946d0","977":"45b37028"}[chunkId] + ".chunk.js";
};